import React from "react";
import { Box, List, ListItem, ListItemButton, Skeleton, alpha, useTheme } from "@mui/material";

// Row widths vary slightly so the skeleton reads as a list rather than a repeated block.
const ROW_WIDTHS: { title: string; bestand: string; datum: string }[] = [
  { title: "70%", bestand: "55%", datum: "40%" },
  { title: "55%", bestand: "45%", datum: "35%" },
  { title: "65%", bestand: "60%", datum: "42%" },
  { title: "50%", bestand: "40%", datum: "38%" },
  { title: "72%", bestand: "50%", datum: "44%" },
  { title: "60%", bestand: "48%", datum: "36%" },
];

// Mirrors HistoryDrawerContent's ListItem/ListItemButton geometry exactly (mb, py, px,
// borderRadius, borderLeft) plus the real body1/caption line-heights (24px / 18px from
// src/theme/typography.ts) so swapping in real rows causes no layout shift.
const HistoryDrawerSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <List sx={{ p: 0, pb: 8 }}>
      {ROW_WIDTHS.map((widths, index) => (
        <ListItem
          key={index}
          disablePadding
          sx={{ mb: 1.5, "&:last-child": { mb: 0 } }}
        >
          <ListItemButton
            disableRipple
            disableTouchRipple
            sx={{
              borderRadius: 1.5,
              py: 1.5,
              px: 2,
              bgcolor: theme.palette.background.neutral,
              borderLeft: "4px solid transparent",
              cursor: "default",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
              <Skeleton variant="text" width={widths.title} height={24} sx={{ bgcolor: alpha(theme.palette.text.primary, 0.11) }} />
              <Skeleton variant="text" width={widths.bestand} height={18} sx={{ bgcolor: alpha(theme.palette.text.primary, 0.11) }} />
              <Skeleton variant="text" width={widths.datum} height={18} sx={{ bgcolor: alpha(theme.palette.text.primary, 0.11) }} />
            </Box>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default HistoryDrawerSkeleton;
